import classNames from 'classnames';
import './radio-block.scss';

export const RadioBlock = (props) => {
    const {
        icon,
        input,
        type,
        label,
        description,
        onClick,
        meta = {},
        className,
        disabled,
        dataCy
    } = props;
    const { error = '' } = meta
    const errorId = input?.name ? `error-radio-${input.name}` : undefined;

    return (
        <>
            <label
                className={classNames(`button-radio-block button-radio border rounded  ${className}`, {
                    'border-danger': input.checked && error,
                    active: input.checked,
                    icon: icon,
                    disabled: disabled,
                })}
                data-cy={dataCy}
            >
                <input
                    type={type}
                    {...input}
                    className="visually-hidden"
                    aria-invalid={error ? 'true' : undefined}
                    aria-describedby={input.checked && error ? errorId : undefined}
                    onClick={!input.name ? input.onChange : onClick}
                    onKeyDown={(e) => {
                        // RGAA 7.4 : empêche la validation/passage automatique à l'étape suivante via Enter sur un radio
                        if (e.key === 'Enter') {
                            e.preventDefault();
                        }
                    }}
                    disabled={disabled}
                />
                {icon && (
                    <div className={'icon'}>
                        <img src={icon} alt="" aria-hidden="true" width={40} />
                    </div>
                )}
                <div className="d-flex flex-column">
                <span dangerouslySetInnerHTML={{ __html: label }} />
                <span dangerouslySetInnerHTML={{ __html: description }} style={{ fontSize: 12 }} className="text-grey" />
                </div>
            </label>
            {input.checked && error && (
                <small id={errorId} className="alert alert-danger invalid-feedback d-block" role="alert">{error}</small>
            )}
        </>
    );
};

